import { ChangeDetectorRef, Component, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { SseService } from 'src/app/services/SseService';

export interface AdminUsuarioRow {
  userId: number;
  email: string;
  userTypeId: number;
  creationDate: string;
  validDays: number;
  duration: number;
  lastLoginDate: string | null;
  lastActivity: string | null;
  carteras: number;
}

export interface AdminCarteraUsuario {
  idcartera: number;
  nombre: string;
  idmercado: number;
  mercado: string | null;
  capitalinicial: number;
  simulado: boolean;
  auto: boolean;
  idmodelo: number | null;
}

@Component({
  selector: 'app-admin-usuario',
  templateUrl: './admin-usuario.component.html',
  styleUrls: ['./admin-usuario.component.scss'],
})
export class AdminUsuarioComponent {
  @Input() isLoadingUsuarios = false;
  @Input() dataSourceUsuarios = new MatTableDataSource<AdminUsuarioRow>([]);
  @Input() displayedColumnsUsuarios: string[] = [
    'userId',
    'email',
    'userTypeId',
    'creationDate',
    'lastLoginDate',
    'lastActivity',
    'carteras',
    'validDays',
    'duration',
    'actions',
  ];

  @Output() recargarUsuarios = new EventEmitter<void>();
  @Output() ajustarDias = new EventEmitter<{ usuario: AdminUsuarioRow; delta: number }>();
  @Output() eliminarUsuario = new EventEmitter<AdminUsuarioRow>();

  @ViewChild('dialogoDetalle') dialogoDetalle!: TemplateRef<any>;

  usuarioDetalle: AdminUsuarioRow | null = null;
  carterasDetalle: AdminCarteraUsuario[] = [];
  isLoadingDetalle = false;
  displayedColumnsCarteras: string[] = ['nombre', 'mercado', 'capitalinicial', 'simulado', 'auto'];

  constructor(
    private sseService: SseService,
    private cookieService: CookieService,
    private dialog: MatDialog,
    private toastr: ToastrService,
    private cdRef: ChangeDetectorRef
  ) {}

  onRecargarUsuarios(): void {
    this.recargarUsuarios.emit();
  }

  onAjustarValidDays(usuario: AdminUsuarioRow, delta: number): void {
    this.ajustarDias.emit({ usuario, delta });
  }

  onEliminarUsuario(usuario: AdminUsuarioRow): void {
    this.eliminarUsuario.emit(usuario);
  }

  verDetalle(usuario: AdminUsuarioRow): void {
    this.usuarioDetalle = usuario;
    this.carterasDetalle = [];
    this.isLoadingDetalle = true;
    this.dialog.open(this.dialogoDetalle, { width: '760px', autoFocus: false });

    const licencia = this.cookieService.get('auth_token');
    this.sseService.apiGetWithAuth(`admin/carterasUsuario?userId=${usuario.userId}`, licencia).subscribe({
      next: (data: AdminCarteraUsuario[]) => {
        this.carterasDetalle = Array.isArray(data) ? data : [];
        this.isLoadingDetalle = false;
        this.cdRef.markForCheck();
      },
      error: (error: any) => {
        console.error('Error al cargar carteras del usuario:', error);
        this.toastr.error(error?.error?.message || 'No fue posible cargar las carteras', 'Error', { timeOut: 5000 });
        this.isLoadingDetalle = false;
        this.cdRef.markForCheck();
      },
    });
  }
}
